'use strict';

/**
 * Warning: This is *not* the same behaviour as the platform-api mapping which supports error messages.
 *
 * While it would technically be possible to pull in
 *
 */
module.exports = {
  endpointsMapper: require('./endpointsMapper'),
  folderMonitorMapper: require('./folderMonitorMapper'),
  jobsMapper: require('./jobsMapper'),
  storageProfileMapper: require('./storageProfileMapper')
};